import DOC_REGISTRY from "../data/docRegistry";
import { datesForSlug } from "./docDates";
import { getWelfareVariant } from "../../../../welfareVariantState";

export const isAkongoStaff = () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    return userData.akongoStaff === true || userData.akongoRank === "board";
  } catch (e) {
    return false;
  }
};

/** Enrichit une entrée du registre avec ses dates createdAt / updatedAt. */
const withDates = (article) => ({ ...article, ...datesForSlug(article.slug) });

export const getVisibleRegistry = (staff = isAkongoStaff(), variant = getWelfareVariant()) => {
  const base = staff
    ? DOC_REGISTRY
    : DOC_REGISTRY.filter((article) => !article.adminOnly);
  // Un laboratoire ne voit pas les articles propres à ZIMS (issue #1096).
  return base.filter((article) => !(variant === "lab" && article.zimsOnly)).map(withDates);
};
